"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdminUserBreadcrumbActivityDto = exports.AdminUserBreadcrumbActivityParentDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
const AdminVenueBreadcrumb_dto_1 = require("./AdminVenueBreadcrumb.dto");
const VenueBreadcrumbReactionSummary_dto_1 = require("./VenueBreadcrumbReactionSummary.dto");
class AdminUserBreadcrumbActivityParentDto {}
exports.AdminUserBreadcrumbActivityParentDto = AdminUserBreadcrumbActivityParentDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminUserBreadcrumbActivityParentDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminUserBreadcrumbActivityParentDto.prototype, "content", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminUserBreadcrumbActivityParentDto.prototype, "createdAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: AdminVenueBreadcrumb_dto_1.AdminVenueBreadcrumbAuthorDto
}), __metadata("design:type", AdminVenueBreadcrumb_dto_1.AdminVenueBreadcrumbAuthorDto)], AdminUserBreadcrumbActivityParentDto.prototype, "author", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], AdminUserBreadcrumbActivityParentDto.prototype, "isFlagged", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: VenueBreadcrumbReactionSummary_dto_1.VenueBreadcrumbReactionSummaryDto,
  isArray: true
}), __metadata("design:type", Array)], AdminUserBreadcrumbActivityParentDto.prototype, "reactions", void 0);
class AdminUserBreadcrumbActivityDto {}
exports.AdminUserBreadcrumbActivityDto = AdminUserBreadcrumbActivityDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminUserBreadcrumbActivityDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.AdminUserBreadcrumbActivityType
}), __metadata("design:type", String)], AdminUserBreadcrumbActivityDto.prototype, "type", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminUserBreadcrumbActivityDto.prototype, "content", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminUserBreadcrumbActivityDto.prototype, "createdAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: AdminVenueBreadcrumb_dto_1.AdminVenueBreadcrumbVenueDto
}), __metadata("design:type", AdminVenueBreadcrumb_dto_1.AdminVenueBreadcrumbVenueDto)], AdminUserBreadcrumbActivityDto.prototype, "venue", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", Number)], AdminUserBreadcrumbActivityDto.prototype, "reactionCount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: VenueBreadcrumbReactionSummary_dto_1.VenueBreadcrumbReactionSummaryDto,
  isArray: true,
  required: false
}), __metadata("design:type", Array)], AdminUserBreadcrumbActivityDto.prototype, "reactions", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", Boolean)], AdminUserBreadcrumbActivityDto.prototype, "isFlagged", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: AdminVenueBreadcrumb_dto_1.AdminVenueBreadcrumbAuthorDto,
  required: false
}), __metadata("design:type", AdminVenueBreadcrumb_dto_1.AdminVenueBreadcrumbAuthorDto)], AdminUserBreadcrumbActivityDto.prototype, "author", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: AdminUserBreadcrumbActivityParentDto,
  required: false
}), __metadata("design:type", AdminUserBreadcrumbActivityParentDto)], AdminUserBreadcrumbActivityDto.prototype, "parentBreadcrumb", void 0);
//# sourceMappingURL=AdminUserBreadcrumbActivity.dto.js.map